import { render } from "./ThinkingAbility.vue?vue&type=template&id=b8c5ab00&scoped=true"
import script from "./ThinkingAbility.vue?vue&type=script&lang=js"
export * from "./ThinkingAbility.vue?vue&type=script&lang=js"

import "./ThinkingAbility.vue?vue&type=style&index=0&id=b8c5ab00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c5ab00"]])

export default __exports__